export enum UserTransactionType {
  REFERRAL = 'REFERRAL',
  EARN = 'EARN',
  PAID = 'PAID',
  ORDER = 'ORDER',
  CREDIT = 'CREDIT',
  SYNC_ORDER = 'SYNC_ORDER',
  REFUND = 'REFUND',
  EXPIRED = 'EXPIRED'
}
export enum UserTransactionDataType {
  invoice = 'INVOICE',
  recipe = 'RECIPE',
  orderDetail = 'ORDER_DETAIL',
  nothing = 'NOTHING'
}

export enum UserTransactionAction {
  IN = 'IN',
  OUT = 'OUT',
}

export enum PaymentRequestStatus {
  INITIALED = 'INITIALED',
  COMPLETED = 'COMPLETED',
  ACTIVE = 'ACTIVE',
  FAIL = 'FAIL',
  TIMEOUT = 'TIMEOUT',
  CANCEL = 'CANCEL',
  PENDING = 'PENDING'
}

export enum PaymentRequestType {
  BUY_CREDIT = 'BUY_CREDIT',
  BUY_SUBSCRIPTION = 'BUY_SUBSCRIPTION',
  PAID_ORDER = 'PAID_ORDER'
}
